module.exports = __webpack_public_path__ + "assets/img/thumb-ImuPro-2-Video.d2a63e18.webp";